import React, { useEffect, useRef } from 'react';
import * as d3 from "d3";

const DonutChartColored = ({
  high, middle, low, highColor, middleColor, lowColor, highText, middleText, lowText, highNote, lowNote,
  neutralColor, textDefaultColor, colorOnly
}) => {
  const ref = useRef(null);

  const width = 300;
  const height = 300;
  const ringPart = 0.3;
  const radius = Math.min(width, height) / 2;
  const keyFont = radius *  0.14;
  const noteFont = radius * 0.09;
  const percFont = radius * 0.11;
  const percTopMargin = 2;

  const draw = () => {
    const total = high + middle + low;

    const list = [
      {
        key: highText,
        note: highNote,
        textColor: highColor,
        textDefaultColor,
        color: colorOnly === 'high' ? highColor : neutralColor,
        value: high
      },
      {
        key: middleText,
        textColor: middleColor,
        textDefaultColor,
        color: colorOnly === 'high' ? middleColor : neutralColor,
        value: middle
      },
      {
        key: lowText,
        note: lowNote,
        textColor: lowColor,
        textDefaultColor,
        color: colorOnly === 'low' ? lowColor : neutralColor,
        value: low
      }
    ];
    const data = total > 0 ? list : [ { key: 'n/a', color: neutralColor, value: 1 } ];

    const svg = d3.select(ref.current);
    svg.select('svg').remove();

    const arc = d3.arc()
      .outerRadius(radius)
      .innerRadius(radius * (1 - ringPart));

    const pie = d3.pie()
      .startAngle(2 * Math.PI)
      .endAngle(0)
      .padAngle(0.0)
      .value((d) => d.value)
      .sort(null);

    const firstG = svg.append("svg")
      .attr("width", width)
      .attr("height", height)
      .attr("viewBox", `0 0 ${width} ${height}`)
      .append("g")
      .attr("transform", `translate(${width / 2}, ${height / 2})`);

    const chart = firstG.selectAll(".arc")
      .data(pie(data))
      .enter();

    chart.append("g")
      .attr("class", "arc")
      .append("path")
      .attr("d", arc)
      .style("fill", (d) => d.data.color);

    if (total > 0) {
      const shifts = [ -86,  -15,  40 ];
      const text = chart.append("text")
        .attr("transform", (d, i) => `translate(0, ${shifts[i]})`)
        .attr("text-anchor", "middle");

      text.append('tspan')
        .attr("x", 0)
        .attr("dy", `${percFont}px`)
        .style("fill", (d) => d.data.textColor)
        .style("font-size", () => `${keyFont}px`)
        .text((d) => d.data.key);

      text.append('tspan')
        .attr("x", 0)
        .attr("dy", `${percFont}px`)
        .style("fill", (d) => d.data.textColor)
        .style("font-size", () => `${noteFont}px`)
        // .style("font-style", () => `italic`)
        .text((d) => d.data.note);

      text.append('tspan')
        .attr("x", 0)
        .attr("dy", `${percFont + percTopMargin}px`)
        .style("fill", (d) => d.data.textDefaultColor)
        .style("font-size", () => `${percFont}px`)
        .text((d) => d.data.value ? `${d.data.value}%` : '0%');
    }
  };

  useEffect(() => {
    if (ref.current) {
      draw();
    }
  }, [ high, middle, low, colorOnly, ref.current ]);

  return (<div className="donut-chart" ref={ ref } />);
};

export default DonutChartColored;
